module.exports = __webpack_public_path__ + "img/bj.e56fe4f9.png";